export default __webpack_public_path__ + "static/media/admins.4806039e.svg";